import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { FilterTypes } from "../../../../enums/FilterTypes";
import SidePanelDisposalsView from "../../layout/SidePanel/layouts/SidePanelDisposalsView";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";

export const DisposalsSchema: ISchema = {
    displayName: "Disposals",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelDisposalsView data={data} onViewPage={onViewPage} />,
    onAdd: (id: string) => window.location.assign(`/view/${EntityNames.disposals}/${id}`),
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'accountId',
            displayName: 'Account',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.accounts,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            descriptor: true,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'disposeMaterialFromYear',
            displayName: 'Year',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            defaultDisplayValue: '--',
            valueFormatter: (val: number) => {
                return val === 1800 ? '--' : val;
            }
        } as ISchemaProperty,
        {
            name: 'disposeMaterialOlderThanYears',
            displayName: 'Material Age (in years)',
            type: PropertyTypes.intNullable,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            valueFormatter: (val: number) => {
                return (val === undefined || val === null || val === 0) ? '--' : val;
            }
        } as ISchemaProperty,
        {
            name: 'caseMaterialTypeId',
            displayName: 'Material Type',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.caseMaterialTypes,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'disposalYears',
            displayName: 'Year',
            type: PropertyTypes.disposalYears,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
        } as ISchemaProperty,
        {
            name: 'materialTypeName',
            displayName: 'Material Type',
            type: PropertyTypes.string,
            entityName: EntityNames.caseMaterialTypes,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty
    ],

    primaryFilter: {
        PropertyName: "FullRef",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.code,
        placeHolder: "Enter a disposal reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "AccountId",
            entityName: EntityNames.accounts,
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid
        } as ISchemaFilter,
        {
            PropertyName: "DisposeMaterialFromYear",
            displayName: "Year",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year
        } as ISchemaFilter,
        {
            PropertyName: "DisposeMaterialOlderThanYears",
            displayName: "Material Age (in years)",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.intNullable
        } as ISchemaFilter,
        {
            PropertyName: "Status",
            entityName: "disposalStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
    ],

    children: [{ entityName: EntityNames.disposalLineItems, displayName: "Boxes", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "DisposalId", canAdd: false } as ISchemaChild,],
};
